angular
    .module('policy.controller')
    .controller('policyClaimSearchController', ['$scope', '$rootScope', '$filter', 'httpService', 'policyService', '$timeout', 'commonConst',
        function ($scope, $rootScope, $filter, httpService, policyService, $timeout, commonConst) {
            $scope.init = function () {
                // search form
                $scope.searchType = $rootScope.pageNavigationHistory.searchType || 'P';
                $scope.searchKey = $rootScope.pageNavigationHistory.searchKey || '';
                $scope.previousSearchKey = $scope.searchKey;
                $scope.filterJurisdiction = $rootScope.pageNavigationHistory.filterJurisdiction;
                $scope.searchPlaceholder = '';
                $scope.searchPageSelected = $rootScope.searchPageSelected || 1;
                $scope.Claims = null;
                $scope.Policies = null;
                $scope.paging = {
                    index: $rootScope.searchPageSelected
                }
                $scope.rowPerPage = $rootScope.pageNavigationHistory.claimPolicySearchRowPerPage || 10;

                // constants and wording
                $scope.pageName = 'Search Policies & Claims';
                $scope.pageBreadcrumbs = [{url: '/', title: 'Home'}, {url: null, title: 'My Policies & Claims'}];
                $scope.IsHiddenTitle = true;
                $scope.allowSpecial = '"&\'()-./';
                $scope.serverResponse;
                $scope.pageWording = policyService.getPageWording();
                $scope.rowSelections = commonConst.ROWS_PER_PAGE_ITEMS;

                // action on link
                $scope.selectPolicyAction = policyService.getSelectPolicyAction();
                $scope.includeCOVPolicy = policyService.getIncludeCOVPolicy();

                var policyCall = function () {
                    $scope.searchPlaceholder = 'Policy Number or Employer Name';
                    if ($scope.searchKey || $rootScope.searchPageSelected != 1) {
                        $scope.getPolicyList($rootScope.searchPageSelected, true);
                    } else {
                        $scope.getPolicyList(1, true);
                    }
                };

                if ($scope.searchType === 'C') {
                    $scope.getClaimList($scope.searchPageSelected, true);
                } else if ($scope.searchType === 'P') {
                    policyCall();
                }
            }

            $scope.clearSearch = function() {
                $scope.searchKey = '';
                $scope.searchPoliciesOrClaims();
            }

            // reset page and related rootscope if change search type
            $scope.changeSearchType = function () {
                $rootScope.pageNavigationHistory.searchType = $scope.searchType;
                $rootScope.pageNavigationHistory.searchKey = $scope.searchKey = '';
                $rootScope.pageNavigationHistory.filterJurisdiction = $scope.filterJurisdiction = null;
                $rootScope.searchPageSelected = $scope.searchPageSelected = 1;
                $scope.paging = {index: null};

                if ($scope.searchType === 'P') {
                    $scope.searchPlaceholder = 'Policy Number or Employer Name';
                    $scope.getPolicyList(1, true);

                } else if ($scope.searchType === 'C') {
                    $scope.searchPlaceholder = 'Claim Number or Worker Name';
                    $scope.getClaimList(1, true);
                }
            }

            // store rootscope for history, clear list of other type then searcg
            $scope.searchPoliciesOrClaims = function () {
                if ($scope.searchType === 'P') {
                    $scope.ClaimCount = 0;
                    $scope.ClaimPageCount = 0
                    $scope.Claims = null;

                    $scope.getPolicyList(1, true);

                } else if ($scope.searchType === 'C') {
                    $scope.PolicyCount = 0;
                    $scope.PolicyPageCount = 0;
                    $scope.Policies = null;

                    $scope.getClaimList(1, true);

                }
            }

            // initializing data for select tag
            $scope.CreateFilterData = function (allOption, selectedOptions) {
                var lstOption = [];
                angular.forEach(allOption, function (value, key) {
                    lstOption.push({
                        label: value,
                        value: key,
                        selected: selectedOptions && selectedOptions.indexOf(key) > -1
                    });
                });

                return lstOption;
            }

            $scope.jurisdictionLst = {
                '0': 'New South Wales',
                '2': 'Victoria'
            };

            $scope.$watch('loaderOn', function () {
                if ($rootScope.loaderOn == false) {
                    $scope.BindFilterControl();

                    $timeout(function () {
                        var policyJurisData = $scope.CreateFilterData($scope.jurisdictionLst, $scope.filterJurisdiction);
                        var claimJurisData = $scope.CreateFilterData($scope.jurisdictionLst, $scope.filterJurisdiction);
                        $('#policy-jurisdiction').multiselect('dataprovider', policyJurisData);
                        $('#claim-jurisdiction').multiselect('dataprovider', claimJurisData);
                    }, 100);
                }
            }, 50);

            $scope.BindFilterControl = function () {
                $timeout(function () {
                    $('#policy-jurisdiction').multiselect({
                        dropRight: true,
                        includeSelectAllOption: true,
                        selectedClass: '',
                        buttonText: function (ele, checked) {
                            return '';
                        },
                        templates: {
                            button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></i>'
                        },

                        onChange: function (ele, checked) {
                            $scope.filterJurisdiction = $('#policy-jurisdiction').val();
                            $scope.getPolicyList(1, true);
                        },
                        onSelectAll: function () {
                            $scope.filterJurisdiction = Object.keys($scope.jurisdictionLst);
                            $scope.getPolicyList(1, true);
                        },
                        onDeselectAll: function () {
                            $scope.filterJurisdiction = null;
                            $scope.getPolicyList(1, true);
                        }
                    });

                    $('#claim-jurisdiction').multiselect({
                        dropRight: true,
                        includeSelectAllOption: true,
                        selectedClass: '',
                        buttonText: function (ele, checked) {
                            return '';
                        },
                        templates: {
                            button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></i>'
                        },

                        onChange: function (ele, checked) {
                            $scope.filterJurisdiction = $('#claim-jurisdiction').val();
                            $scope.getClaimList(1, true);
                        },
                        onSelectAll: function () {
                            $scope.filterJurisdiction = Object.keys($scope.jurisdictionLst);
                            $scope.getClaimList(1, true);
                        },
                        onDeselectAll: function () {
                            $scope.filterJurisdiction = null;
                            $scope.getClaimList(1, true);
                        }
                    });
                }, 100);
            }

            $scope.selectRow = function(rowPerPage) {
                $scope.rowPerPage = rowPerPage;
                $scope.searchPageSelected = 1;
                if ($scope.searchType === 'C') {
                    $scope.getClaimList($scope.searchPageSelected, true);
                } else if ($scope.searchType === 'P') {
                    $scope.getPolicyList(1, true);
                }
            }


            /* AREA Claim **************************************************************************************/
            $scope.getClaimList = function (num, isFirstSearch, callback) {
                // if (!$scope.searchKey || $scope.searchKey.trim() === '') { 
                //     $scope.ClaimCount = 0;
                //     $scope.ClaimPageCount = 0
                //     $scope.Claims = null;
                //     return; 
                // }
                $scope.searchPlaceholder = 'Claim Number or Worker Name';
                $rootScope.searchPageSelected = $scope.searchPageSelected = num;
                $scope.searchKey = $filter('undefined')($scope.searchKey) ? "" : $scope.searchKey;
                $rootScope.pageNavigationHistory.searchKey = $scope.searchKey;
                $rootScope.pageNavigationHistory.filterJurisdiction = $scope.filterJurisdiction;
                $rootScope.pageNavigationHistory.claimPolicySearchRowPerPage = $scope.rowPerPage;

                var APITarget = "api/vicclaims/getvicclaimsummarybyidentifier";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    Keyword: $scope.searchKey,
                    RowsPerPage: $scope.rowPerPage,
                    PageNumber: num,
                    IsFirstSearch: isFirstSearch,
                    BusinessUnit: $rootScope.combineJurisdiction($scope.filterJurisdiction),
                    SortBy: 2,
                    IsClaimant: $rootScope.IsClaimant
                });
                httpService.httpRequest(APITarget, Values).then(function (data) { // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        $scope.serverResponse = angular.fromJson(data);
                        $scope.ClaimPageCount = {
                            Pages: []
                        };

                        // if page count is zero, this is not the first search
                        if ($scope.serverResponse.PageCount) {
                            $scope.ClaimCount = $scope.serverResponse.PageCount;
                            $scope.searchTotalResult = $scope.serverResponse.ClaimCount;

                            var counterPage = 0;
                            for (var i = 0; i < $scope.ClaimCount; i++) {
                                counterPage++;
                                $scope.ClaimPageCount.Pages.push(counterPage);
                            }
                        }

                        $scope.Claims = $scope.serverResponse.ClaimList.Data;
                    }

                    if (callback) {
                        callback();
                    }
                });

            };

            $scope.goToClaimPageByInput = function (numberOfPage) {
                if (numberOfPage == "" || numberOfPage == 0 || numberOfPage > $scope.ClaimPageCount.Pages.length) {
                    return;
                }
                $scope.getClaimList(numberOfPage, false);
                $scope.numberOfClaimPage = parseInt(numberOfPage);
            }

            //set disable Go button
            $scope.buttonClaimGoDisabled = true;
            $scope.setVisibleButtonClaimGo = function (numberOfPage) {
                $scope.numberOfClaimPage = "";
                if (!(numberOfPage == "" || numberOfPage == 0 || numberOfPage > $scope.ClaimPageCount.Pages.length)) {
                    $scope.buttonClaimGoDisabled = false;
                } else {
                    $scope.buttonClaimGoDisabled = true;
                }
                $scope.numberOfClaimPage = numberOfPage;
            }
            /* END AREA Claim **********************************************************************************/


            /* AREA Policy *************************************************************************************/
            $scope.getPolicyList = function (num, isFirstSearch) {
                $rootScope.searchPageSelected = $scope.searchPageSelected = num || 1;
                $scope.searchKey = $filter('undefined')($scope.searchKey) || !$scope.searchKey ? "" : $scope.searchKey;
                $rootScope.pageNavigationHistory.searchKey = $scope.searchKey;
                $rootScope.pageNavigationHistory.filterJurisdiction = $scope.filterJurisdiction;
                $rootScope.pageNavigationHistory.claimPolicySearchRowPerPage = $scope.rowPerPage;

                var APITarget = "api/vicpolicies/getvicpoliciessummary";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    Keyword: $scope.searchKey,
                    RowsPerPage: $scope.rowPerPage,
                    PageNumber: num,
                    IncludeCOVPolicy: $scope.includeCOVPolicy,
                    BusinessUnit: $rootScope.combineJurisdiction($scope.filterJurisdiction)
                });
                httpService.httpRequest(APITarget, Values).then(function (data) { // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        $scope.serverResponse = angular.fromJson(data);

                        // if page count is zero, this is not the first search
                        if ($scope.serverResponse.PageCount) {
                            $scope.PolicyCount = $scope.serverResponse.PageCount;
                            $scope.searchTotalResult = $scope.serverResponse.RowsCount;
                            $scope.PolicyPageCount = {
                                Pages: []
                            };
                            var counterPage = 0;
                            for (var i = 0; i < $scope.PolicyCount; i++) {
                                counterPage++;
                                $scope.PolicyPageCount.Pages.push(counterPage);
                            }
                        }

                        $scope.Policies = $scope.serverResponse.PolicyList;
                    }
                });

            };

            $scope.goToPolicyPageByInput = function (numberOfPage) {
                if (numberOfPage == "" || numberOfPage == 0 || numberOfPage > $scope.PolicyPageCount.Pages.length) {
                    return;
                }
                $scope.getPolicyList(numberOfPage, false);
                $scope.numberOfPolicyPage = parseInt(numberOfPage);
            }

            //set disable Go button
            $scope.buttonPolicyGoDisabled = true;
            $scope.setVisibleButtonPolicyGo = function (numberOfPage) {
                $scope.numberOfPolicyPage = "";
                if (!(numberOfPage == "" || numberOfPage == 0 || numberOfPage > $scope.PolicyPageCount.Pages.length)) {
                    $scope.buttonPolicyGoDisabled = false;
                } else {
                    $scope.buttonPolicyGoDisabled = true;
                }
                $scope.numberOfPolicyPage = numberOfPage;
            }
            /* END AREA Policy *********************************************************************************/
        }
    ]);